'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tooltip/lib/index.js
 ** module id = 269
 ** module chunks = 0
 **/